import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { usePublicAgentConfig } from "@/features/chat/api/public-agent";
import { PublicChatPage } from "@/features/chat/ui/PublicChatWidget";

export const Route = createFileRoute("/_public/a/$orgId/$agentId")({
  component: PublicAgentRoute,
});

function PublicAgentRoute() {
  const { orgId, agentId } = Route.useParams();
  const { data, isLoading, error } = usePublicAgentConfig(orgId, agentId);
  const [widgetContext, setWidgetContext] = useState<Record<string, unknown> | undefined>();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-6 w-6 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }

  const isNotFound = error?.message === "not_found" || !data;

  if (isNotFound) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-2 text-center px-4">
        <p className="text-lg font-semibold text-foreground">Agent not found</p>
        <p className="text-sm text-muted-foreground">
          This agent does not exist or is not currently available.
        </p>
      </div>
    );
  }

  return (
    <PublicChatPage
      agentId={data.agent_id}
      orgId={data.org_id}
      displayName={data.display_name}
      widgetContext={widgetContext}
      onWidgetContextChange={(ctx) =>
        setWidgetContext((prev) => (prev ? { ...prev, ...ctx } : ctx))
      }
    />
  );
}
